export default {"src":"/_next/static/media/JCI.67e3366d.svg","height":18,"width":18};